import React from 'react';


const AnnouncementToolbar = () => {
    return (
        <div className="announcement-toolbar">
            <div className="announcement-text">

                You dream; we fund. With us, your dream can become. Apply for our ongoing university scholarship today!
            </div>
        </div>
    );
};

export default AnnouncementToolbar;
